import * as React from 'react'
import {GQL_SearchType} from '../../generated/graphql'
import {Box} from '../../webui/Box'
import {Button} from '../../webui/Button'
import {Typography} from '../../webui/Typography'
import {useAllRentals} from '../rentals/gql/useAllRentals'
import {RentalsTable} from '../rentals/RentalsTable'
import {CircularProgress} from '../../webui/progress/CircularProgress'

interface Props {
  searchTerm?: string
}

const paginationLimit = 100

export const RentalActionsTable: React.FC<Props> = ({searchTerm}) => {
  const {data, loading, error, fetchMore} = useAllRentals({
    variables: {
      pagination: {
        offset: 0,
        limit: paginationLimit,
      },
      filter: {
        mayNeedAction: true,
      },
      search: searchTerm
        ? {
            box: {
              query: searchTerm,
              type: GQL_SearchType.Contains,
            },
            product: {
              query: searchTerm,
              type: GQL_SearchType.Contains,
            },
            rentByUser: {
              query: searchTerm,
              type: GQL_SearchType.Contains,
            },
          }
        : undefined,
    },
    notifyOnNetworkStatusChange: true,
  })

  const allFetchedRentals = data?.rentals || []
  const totalCount = data?.totalCount || 0

  const onFetchMoreClicked = async () => {
    if (loading || !data?.rentals) {
      return
    }
    await fetchMore({
      variables: {
        pagination: {
          offset: allFetchedRentals.length,
          limit: paginationLimit,
        },
      },
    })
  }

  const canFetchMore = allFetchedRentals.length < totalCount

  return (
    <Box>
      <RentalsTable
        error={error}
        loading={loading && allFetchedRentals.length === 0}
        rentals={allFetchedRentals}
        searchEnabled={false}
        showContractType={false}
      />
      <Box alignItems={'flex-end'} display={'flex'} justifyContent={'flex-end'} pb={1} pr={1}>
        <Button
          onClick={onFetchMoreClicked}
          disabled={!canFetchMore || loading}
          startIcon={loading && canFetchMore ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {canFetchMore ? `Fetch ${paginationLimit} more` : 'All rentals fetched'}
        </Button>
        <Box ml={2} />
        <Typography variant={'h6'}>Total: {totalCount}</Typography>
      </Box>
    </Box>
  )
}
